module.exports = __webpack_public_path__ + "static/media/dc3-data.efda0096.jpg";